import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { settingsAPI } from '../services/api';
import { getFileUrl } from '../utils/fileUtils';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [logo, setLogo] = useState(null);
  const [companyName, setCompanyName] = useState('HALLSTATT');

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const settings = await settingsAPI.get();
      if (settings.logo) {
        setLogo(getFileUrl(settings.logo));
      }
      if (settings.companyName) {
        setCompanyName(settings.companyName);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-stone-200 shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            {logo ? (
              <img 
                src={logo} 
                alt={companyName} 
                className="h-14 w-auto object-contain"
                style={{ maxWidth: '200px' }}
              />
            ) : (
              <div className="text-2xl font-bold text-stone-800 tracking-tight">
                {companyName}
              </div>
            )}
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-stone-700 hover:text-clay-primary font-medium transition-colors duration-200"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('machines')}
              className="text-stone-700 hover:text-clay-primary font-medium transition-colors duration-200"
            >
              Máquinas
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-stone-700 hover:text-clay-primary font-medium transition-colors duration-200"
            >
              Sobre Nosotros
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-stone-700 hover:text-clay-primary font-medium transition-colors duration-200"
            >
              Contacto
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-stone-700 hover:text-clay-primary transition-colors"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 space-y-2 border-t border-stone-200">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left px-4 py-2 text-stone-700 hover:bg-stone-50 hover:text-clay-primary font-medium transition-colors"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('machines')}
              className="block w-full text-left px-4 py-2 text-stone-700 hover:bg-stone-50 hover:text-clay-primary font-medium transition-colors"
            >
              Máquinas
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-2 text-stone-700 hover:bg-stone-50 hover:text-clay-primary font-medium transition-colors"
            >
              Sobre Nosotros
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-2 text-stone-700 hover:bg-stone-50 hover:text-clay-primary font-medium transition-colors"
            >
              Contacto
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
